export default function StatCard({ title, value, colorClass = '', subtitle, icon }) {
  return (
    <div className="stat-card">
      <div className="stat-card__label">{title}</div>
      <div className="stat-card__middle">
        <div className="stat-card__icon">
          {icon && <div className="stat-card__icon">{icon}</div>}
        </div>
        <div className="stat-card__value val--blue">{value}</div>
      </div>
      <div className="stat-card__subtitle">{subtitle}</div>
    </div>
  )
}
